module.exports = __webpack_public_path__ + "img/icon_collected.28a09856.svg";